export const AED_WAIT_TIME_IN_SECONDS = 30;
export const AED_SECONDS_LEFT_TO_ALERT = 5;
